import { z } from 'zod';
import { opportunityCloseReasonSchema, opportunityRoundStateSchema, verifierStateForHistorySchema, } from './opportunity-history.js';
const idStringSchema = z.string().trim().min(1);
const timestampSchema = z.string().trim().min(1);
const jsonObjectSchema = z.record(z.string(), z.unknown());
const nullableJsonObjectSchema = jsonObjectSchema.nullable();
export const opportunityReviewVerdictLabelSchema = z.enum([
    'useful',
    'not_useful',
    'inconclusive',
    'invalid_signal',
]);
export const opportunityReviewStatusSchema = z.enum([
    'all',
    'reviewed',
    'unreviewed',
]).default('all');
export const opportunityReviewSortSchema = z.enum([
    'newest_closed',
    'oldest_closed',
    'highest_edge',
    'lowest_edge',
]).default('newest_closed');
export const opportunityRoundVerdictSchema = z.object({
    id: idStringSchema,
    opportunityRoundId: idStringSchema,
    verdictLabel: opportunityReviewVerdictLabelSchema,
    notes: z.string().nullable().default(null),
    reviewerUserId: idStringSchema.nullable().default(null),
    reviewerEmail: z.string().email().nullable().default(null),
    createdAt: timestampSchema,
});
export const createOpportunityRoundVerdictSchema = z.object({
    verdictLabel: opportunityReviewVerdictLabelSchema,
    notes: z.string().trim().max(4000).optional().nullable().transform(value => value || null),
});
export const opportunityReviewQueueQuerySchema = z.object({
    reviewStatus: opportunityReviewStatusSchema,
    verifierState: verifierStateForHistorySchema.optional(),
    verdictLabel: opportunityReviewVerdictLabelSchema.optional(),
    opportunityType: idStringSchema.optional(),
    q: z.string().trim().min(1).max(120).optional(),
    sort: opportunityReviewSortSchema,
    limit: z.coerce.number().int().positive().max(100).default(50),
});
export const opportunityReviewRoundQueueItemSchema = z.object({
    opportunityRoundId: idStringSchema,
    opportunityId: idStringSchema,
    opportunityType: idStringSchema,
    title: idStringSchema,
    outcomeLabel: idStringSchema,
    verifierState: verifierStateForHistorySchema.nullable().default(null),
    currentEdgeBps: z.number().int().min(-10000).max(10000).nullable().default(null),
    openedAt: timestampSchema,
    closedAt: timestampSchema.nullable().default(null),
    frozenAt: timestampSchema.nullable().default(null),
    reviewStatus: z.enum(['reviewed', 'unreviewed']),
    latestVerdict: opportunityRoundVerdictSchema.nullable().default(null),
});
export const opportunityReviewRoundQueueSchema = z.object({
    items: z.array(opportunityReviewRoundQueueItemSchema),
    meta: z.object({
        returnedCount: z.number().int().min(0),
        limit: z.number().int().positive().max(100),
        filters: z.object({
            reviewStatus: opportunityReviewStatusSchema,
            verifierState: verifierStateForHistorySchema.nullable().default(null),
            verdictLabel: opportunityReviewVerdictLabelSchema.nullable().default(null),
            opportunityType: idStringSchema.nullable().default(null),
            q: z.string().trim().min(1).max(120).nullable().default(null),
        }),
        sort: opportunityReviewSortSchema,
    }),
});
export const opportunityReviewRoundDetailSchema = z.object({
    opportunityRoundId: idStringSchema,
    opportunityId: idStringSchema,
    roundSequence: z.number().int().positive(),
    state: opportunityRoundStateSchema,
    openedAt: timestampSchema,
    firstVisibleAt: timestampSchema,
    closedAt: timestampSchema.nullable().default(null),
    frozenAt: timestampSchema.nullable().default(null),
    closeReason: opportunityCloseReasonSchema.nullable().default(null),
    representativeSourceSnapshot: nullableJsonObjectSchema,
    frozenOpportunitySnapshot: nullableJsonObjectSchema,
    frozenVerifierSnapshot: nullableJsonObjectSchema,
    latestVerdict: opportunityRoundVerdictSchema.nullable().default(null),
    verdictHistory: z.array(opportunityRoundVerdictSchema),
});
